import { makeStyles } from '@fluentui/react-components';
const colors = {
    foreground: `var(--colorNeutralForeground2,--ms-themeColorBodySubtext)`,
    brand: `var(--colorBrandForeground1,--ms-themeColorPaletteThemePrimary)`
};
export const useLocationAnimatedStyles = makeStyles({
    leaf: {
        stroke: colors.foreground,
        fill: 'none',
        transformOrigin: 'center'
    },
    leavesOver: {
        transformOrigin: 'center',
        animationDuration: '283ms',
        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)',
        animationFillMode: 'forwards',
        animationName: {
            '100%': {
                transform: 'rotate(-90deg)'
            }
        }
    },
    leafOver: {
        fill: colors.brand,
        stroke: colors.brand,
        animationDuration: '183ms',
        animationTimingFunction: 'cubic-bezier(0.17, 0.17, 0.3, 1)',
        animationDelay: '100ms',
        animationFillMode: 'forwards'
    },
    leaf1Over: {
        animationName: {
            '50%': {
                opacity: 1
            },
            '100%': {
                opacity: 0,
                scale: 0.5,
                transform: 'translate(-6px, -6px)'
            }
        }
    },
    leaf2Over: {
        animationName: {
            '50%': {
                opacity: 1
            },
            '100%': {
                opacity: 0,
                scale: 0.5,
                transform: 'translate(-6px, 6px)'
            }
        }
    },
    leaf3Over: {
        animationName: {
            '50%': {
                opacity: 1
            },
            '100%': {
                opacity: 0,
                scale: 0.5,
                transform: 'translate(6px, -6px)'
            }
        }
    },
    leaf4Over: {
        animationName: {
            '50%': {
                opacity: 1
            },
            '100%': {
                opacity: 0,
                scale: 0.5,
                transform: 'translate(6px, 6px)'
            }
        }
    },
    leafOut: {
        transformOrigin: 'center',
        animationDuration: '517ms',
        animationTimingFunction: 'cubic-bezier(0.17, 0.17, 0.67, 1)',
        animationDelay: '0ms',
        animationFillMode: 'forwards'
    },
    leaf1Out: {
        animationName: {
            '0%': {
                scale: 0.6,
                transform: 'translate(-6px, -6px)'
            },
            '29%': {
                scale: 1,
                transform: 'translate(1px, 1px)'
            },
            '30%': {
                transform: 'translate(1px, 1px)',
                animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)'
            },
            '100%': {
                translate: 'initial'
            }
        }
    },
    leaf2Out: {
        animationName: {
            '0%': {
                scale: 0.6,
                transform: 'translate(-6px, 6px)'
            },
            '29%': {
                scale: 1,
                transform: 'translate(1px, -1px)'
            },
            '30%': {
                transform: 'translate(1px, -1px)',
                animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)'
            },
            '100%': {
                translate: 'initial'
            }
        }
    },
    leaf3Out: {
        animationName: {
            '0%': {
                scale: 0.6,
                transform: 'translate(6px, -6px)'
            },
            '29%': {
                scale: 1,
                transform: 'translate(-1px, 1px)'
            },
            '30%': {
                transform: 'translate(-1px, 1px)',
                animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)'
            },
            '100%': {
                translate: 'initial'
            }
        }
    },
    leaf4Out: {
        animationName: {
            '0%': {
                scale: 0.6,
                transform: 'translate(6px, 6px)'
            },
            '29%': {
                scale: 1,
                transform: 'translate(-1px, -1px)'
            },
            '30%': {
                transform: 'translate(-1px, -1px)',
                animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)'
            },
            '100%': {
                translate: 'initial'
            }
        }
    },
    dots: {
        opacity: 0
    },
    dotsOver: {
        opacity: 1,
        '> circle': {
            fill: colors.brand,
            opacity: 0,
            transformOrigin: 'center',
            scale: 0.6,
            animationDuration: '283ms',
            animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)',
            animationFillMode: 'forwards',
            animationName: {
                '50%': {
                    opacity: 1,
                    scale: 0.8
                },
                '100%': {
                    opacity: 1,
                    transform: 'rotate(-90deg)',
                    scale: 1
                }
            }
        }
    },
    lineOver: {
        stroke: colors.brand,
        scale: 0.6,
        transformOrigin: 'center',
        strokeWidth: '1',
        strokeDasharray: '2 2.2',
        strokeLinecap: 'round',
        animationDuration: '283ms, 8s',
        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1), linear',
        animationIterationCount: '1, infinite',
        animationFillMode: 'forwards, forwards',
        animationName: [
            {
                '100%': {
                    rotate: '-90deg',
                    scale: 1
                }
            },
            {
                '100%': {
                    strokeDashoffset: '38'
                }
            }
        ]
    }
});
